import AppState from '../AppState';
import getAddressServiceQualificationManual from './getAddressServiceQualificationManual';
import addressFieldsModel from "../models/addressFieldsModel";
/**
 * Extracts the values from a form and validates them.
 *
 * @param {HTMLFormElement} form - The form to extract values from.
 * @returns {Object} - An object containing the extracted form values and
 *                    a boolean indicating whether the form is valid.
 */
const extractFormValuesAndValidate = (form) => {
    const formData = new FormData(form);
    const values = {};
    const missingFields = [];
    for (const [name, value] of formData.entries()) {
        values[name] = value;
        const input = form.querySelector(`[name="${name}"]`);
        if (input && input.classList.contains('required') && (typeof value === "string" && value.trim() === '')) {
            missingFields.push(name);
            input.classList.add('missing-field');
        }
        else if (input) {
            input.classList.remove('missing-field');
        }
    }
    const isValid = missingFields.length === 0;
    return { values, isValid };
};
/**
 * Submits a manual address form and performs necessary actions based on the form validity.
 *
 * @param {Event} event - The event object triggered by the form submission.
 * @param {HTMLFormElement} manualAddressForm - The manual address form element.
 */
const submitManualAddress = (event, manualAddressForm) => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { context } = drupalJsObjects;
    const { values, isValid } = extractFormValuesAndValidate(manualAddressForm);
    if (!isValid) {
        event.preventDefault();
    }
    else {
        const modal = context.querySelector('#manual-address');
        if (modal) {
            modal.classList.remove('show');
            modal.setAttribute('aria-hidden', 'true');
            const backdrop = context.querySelector('.modal-backdrop');
            if (backdrop) {
                backdrop.parentNode.removeChild(backdrop);
            }
            context.body.style.overflow = 'auto';
            context.body.style.paddingRight = '0';
        }
        manualAddressForm.reset();
        const requiredAddressFields = addressFieldsModel;
        const addressValues = requiredAddressFields.reduce((acc, field) => {
            var _a;
            return Object.assign(Object.assign({}, acc), { [field]: (_a = values[field]) !== null && _a !== void 0 ? _a : '' });
        }, {});
        getAddressServiceQualificationManual(addressValues)
            .catch(error => console.log(error));
        modal.remove();
    }
};
export default submitManualAddress;
